var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 24,
    viewBox: "0 0 64 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7582_14895)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.7357 23.6545H22.5513L25.794 0.421875H30.9782L27.7357 23.6545Z",
    fill: "#00579F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5263 0.989106C45.5037 0.519026 43.8818 0 41.8762 0C36.7564 0 33.1511 3.16343 33.129 7.68618C33.0865 11.0231 35.7103 12.8764 37.6727 13.9891C39.6785 15.126 40.3604 15.8681 40.3604 16.8815C40.3399 18.4379 38.7396 19.1553 37.2469 19.1553C35.177 19.1553 34.068 18.7854 32.3825 17.9195L31.6999 17.5483L30.9744 22.7635C32.1903 23.4054 34.4306 23.975 36.7564 24C42.1963 24 45.7379 20.8855 45.7798 16.0658C45.8005 13.4211 44.415 11.3946 41.428 9.73863C39.6147 8.67561 38.5042 7.95883 38.5042 6.87118C38.5255 5.8824 39.4435 4.86964 41.4904 4.86964C43.1758 4.82004 44.4142 5.28946 45.3523 5.75921L45.8212 6.00591L46.5263 0.989106Z",
    fill: "#00579F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4186 15.424C53.8456 14.0893 55.4885 8.92371 55.4885 8.92371C55.4669 8.97332 55.9146 7.56439 56.1706 6.69946L56.5329 8.70132C56.5329 8.70132 57.5147 14.2624 57.7279 15.424C56.9176 15.424 54.4426 15.424 53.4186 15.424ZM59.8182 0.421875H55.808C54.5714 0.421875 53.6318 0.841694 53.0983 2.3495L45.3974 23.6542H50.8373C50.8373 23.6542 51.7329 20.7867 51.9254 20.1692C52.5222 20.1692 57.8141 20.1692 58.5818 20.1692C58.7307 20.9848 59.2004 23.6542 59.2004 23.6542H64.0007L59.8182 0.421875Z",
    fill: "#00579F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.223 0.421875L13.1457 16.2643L12.5909 13.0513C11.6522 9.34386 8.70832 5.31583 5.42307 3.31298L10.0737 23.6299H15.5561L23.7051 0.421875H18.223Z",
    fill: "#00579F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.42661 0.421875H0.0853345L0 0.891297C6.50671 2.81925 10.816 7.4665 12.5865 13.0523L10.7732 2.37479C10.4746 0.890969 9.55722 0.470821 8.42661 0.421875Z",
    fill: "#FAA61A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7582_14895"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.65ffcb8bc5ba09deff68f691e9ac3da6.svg";
export { ForwardRef as ReactComponent };